import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleChartsModule } from 'angular-google-charts';
import { GoogleMapsModule } from '@angular/google-maps'
import { GoogleMapComponent } from './google-map.component';

@NgModule({
	declarations: [
		GoogleMapComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		GoogleChartsModule,
		GoogleMapsModule
	],
	exports: [
		GoogleChartsModule,
		GoogleMapsModule,
		GoogleMapComponent
	],
})
export class GoogleMapComponentModule { }
